import React from "react"

const PhoneIcon = ({ white, onClick }) => {
  return (
    <svg 
        width="32" 
        height="32" 
        viewBox="0 0 32 32" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
    >
<path 
    d="M3 9C3 20.0464 11.9536 29 23 29H26C27.656 29 29 27.656 29 26V24.1712C29.0003 23.8365 28.8887 23.5114 28.6828 23.2475C28.4769 22.9837 28.1887 22.7963 27.864 22.7152L21.9664 21.2416C21.6801 21.17 21.3791 21.1845 21.101 21.2833C20.8229 21.3821 20.5802 21.5607 20.4032 21.7968L19.1088 23.5216C18.9303 23.7683 18.6769 23.9509 18.3864 24.0423C18.0959 24.1337 17.7836 24.1289 17.496 24.0288C15.313 23.2262 13.3305 21.9587 11.6859 20.3141C10.0413 18.6695 8.77376 16.687 7.9712 14.504C7.87106 14.2164 7.86632 13.9041 7.95768 13.6136C8.04905 13.3231 8.23166 13.0697 8.4784 12.8912L10.2032 11.5968C10.4392 11.4197 10.6177 11.1769 10.7164 10.8989C10.8152 10.6209 10.8298 10.3199 10.7584 10.0336L9.2848 4.136C9.20347 3.81144 9.01601 3.52336 8.75221 3.31754C8.48841 3.11172 8.1634 2.99995 7.8288 3H6C4.3424 3 3 4.344 3 6V9Z" 
    stroke={white ? "white" : "#212616"}
    stroke-width="1.2" 
    stroke-linecap="round" 
    stroke-linejoin="round"/>
</svg>
  )
}

export default PhoneIcon